export default () => (
  <svg
    width="42"
    height="36"
    viewBox="0 0 42 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0022 29.4428C22.1857 29.4428 23.1451 28.4834 23.1451 27.2999C23.1451 26.1165 22.1857 25.1571 21.0022 25.1571C19.8188 25.1571 18.8594 26.1165 18.8594 27.2999C18.8594 28.4834 19.8188 29.4428 21.0022 29.4428Z"
      fill="currentColor"
    />
    <path
      d="M20.7907 10.5857C19.4622 10.7142 18.4765 11.8714 18.605 13.1999L19.4193 21.9857C19.505 22.7571 20.105 23.3571 20.8765 23.4428C21.7765 23.5285 22.5479 22.8856 22.6336 21.9857L23.4479 13.1999C23.4479 13.0714 23.4479 12.8999 23.4479 12.7714C23.2765 11.4428 22.1193 10.4571 20.7907 10.5857Z"
      fill="currentColor"
    />
    <path
      d="M40.5038 27L26.1038 2.91429C25.0324 1.07143 23.1038 0 21.0038 0C18.9038 0 16.9753 1.07143 15.9038 2.91429L1.50383 27C0.389548 28.8857 0.346691 31.1143 1.41812 33C2.48955 34.8857 4.41812 36 6.60383 36H35.361C37.5467 36 39.4753 34.8857 40.5467 33C41.661 31.1143 41.6181 28.8429 40.5038 27ZM37.5467 31.2857C37.1181 32.0571 36.3038 32.5286 35.4038 32.5286H6.60383C5.70383 32.5286 4.88955 32.0571 4.46098 31.2857C4.03241 30.5143 4.03241 29.5714 4.50383 28.8L18.861 4.67143C19.3324 3.9 20.1038 3.47143 21.0038 3.47143C21.9038 3.47143 22.6753 3.9 23.1467 4.67143L37.5467 28.7571C37.9753 29.5714 37.9753 30.4714 37.5467 31.2857Z"
      fill="currentColor"
    />
  </svg>
);
